/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Sandboxchangelogprefix3Inputs */

const id_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda dapat melihat changelog untuk seluruh produk di`)
};

const ms_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda boleh melihat changelog untuk keseluruhan produk di`)
};

const da_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan se ændringsloggen for hele produktet i`)
};

const de_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie können das Änderungsprotokoll für das gesamte Produkt im`)
};

const en_us2_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can see the changelog for the whole product in the`)
};

const es_es2_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes ver el registro de cambios de todo el producto en el`)
};

const es_mx2_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes ver el registro de cambios de todo el producto en el`)
};

const fil_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maaari mong makita ang talaan ng pagbabago para sa buong produkto sa`)
};

const fr_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez voir le journal des modifications de l'ensemble du produit dans le`)
};

const it_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi vedere il registro modifiche per l'intero prodotto nel`)
};

const hu_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A teljes termék változásnaplóját itt tekintheted meg:`)
};

const nl_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je kunt het wijzigingslogboek voor het hele product zien in het`)
};

const no_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan se endringsloggen for hele produktet i`)
};

const pl_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Możesz zobaczyć dziennik zmian całego produktu w`)
};

const pt_br2_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você pode ver o changelog de todo o produto no`)
};

const pt_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pode ver o registo de alterações de todo o produto na`)
};

const ro_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poți vedea jurnalul de modificări pentru întregul produs în`)
};

const fi_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voit nähdä koko tuotteen muutoslokin`)
};

const sv_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan se ändringsloggen för hela produkten i`)
};

const vi_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn có thể xem nhật ký thay đổi cho toàn bộ sản phẩm trong`)
};

const tr_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm ürünün değişiklik günlüğünü şurada görebilirsiniz:`)
};

const cs_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam změn pro celý produkt si můžete prohlédnout v`)
};

const bg_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Можете да видите дневника на промените за целия продукт в`)
};

const ru_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы можете просмотреть журнал изменений для всего продукта в`)
};

const uk_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви можете переглянути журнал змін для всього продукту в`)
};

const ar_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمكنك رؤية سجل التغييرات للمنتج بأكمله في`)
};

const hi_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप पूरे उत्पाद का बदलाव लॉग इसमें देख सकते हैं`)
};

const th_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสามารถดูบันทึกการเปลี่ยนแปลงสำหรับผลิตภัณฑ์ทั้งหมดได้ใน`)
};

const ja_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`製品全体の更新履歴はこちらで確認できます：`)
};

const zh_cn2_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您可以在以下页面查看整个产品的更新日志：`)
};

const zh_hant1_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您可以在以下頁面檢視整個產品的更新日誌：`)
};

const ko_offerdetail_changelog_sandboxchangelogprefix3 = /** @type {(inputs: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 제품의 변경 내역은 다음에서 확인할 수 있습니다`)
};

/**
* | output |
* | --- |
* | "You can see the changelog for the whole product in the" |
*
* @param {Offerdetail_Changelog_Sandboxchangelogprefix3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_sandboxchangelogprefix3 = /** @type {((inputs?: Offerdetail_Changelog_Sandboxchangelogprefix3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Sandboxchangelogprefix3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "da") return da_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "de") return de_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "it") return it_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "no") return no_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "th") return th_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_sandboxchangelogprefix3(inputs)
	return ko_offerdetail_changelog_sandboxchangelogprefix3(inputs)
});
export { offerdetail_changelog_sandboxchangelogprefix3 as "offerDetail.changelog.sandboxChangelogPrefix" }